<template>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <sidebar-collapse />
      <GlobalSearch />
    </div>
    <ul class="list-unstyled topbar-right-menu float-end mb-0">
      <LanguageSwitcher />
      <AdminNotifications />
      <li ref="userProfileRef" class="dropdown notification-list">
        <a
          class="nav-link dropdown-toggle nav-user arrow-none me-0"
          href="javascript:void(0)"
          role="button"
          @click="toggleProfileDropDown"
        >
          <span class="account-user-avatar">
            <base-avatar
              class="avatar-circle-sm"
              :firstname="user.firstname"
              :lastname="user.lastname"
              :randombg="true"
            ></base-avatar>
          </span>
          <span>
            <span class="account-user-name"> {{ user.firstname }} {{ user.lastname }} </span>
            <span class="account-position">{{ role }}</span>
          </span>
        </a>
        <dropdown
          class="dropdown-menu dropdown-menu-right dropdown-menu-animated profile-dropdown"
          item-class="profile-dropdown"
          :show="showProfile"
        >
          <!-- item-->
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{ $t('views.layouts.welcome') }}</h6>
          </div>

          <!-- item-->
          <router-link
            :to="{ name: 'admin.account.general', state: { id: user.id } }"
            class="dropdown-item notify-item text-decoration-none"
          >
            <i class="mdi mdi-account-circle me-1"></i>
            <span>{{ $t('views.layouts.my_account') }}</span>
          </router-link>

          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item notify-item" @click="logout">
            <i class="mdi mdi-logout me-1"></i>
            <span>{{ $t('views.layouts.exit') }}</span>
          </a>
        </dropdown>
      </li>
    </ul>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

import BaseAvatar from '@/components/BaseAvatar'

import Dropdown from '@/components/Dropdown'
import GlobalSearch from '@/components/GlobalSearch'
import SidebarCollapse from '@/components/SidebarCollapse'
import AdminNotifications from '@/views/layouts/AdminNotifications'
import LanguageSwitcher from '@/views/layouts/LanguageSwitcher'

export default {
  components: {
    BaseAvatar,
    LanguageSwitcher,
    AdminNotifications,
    Dropdown,
    SidebarCollapse,
    GlobalSearch
  },
  data() {
    return {
      showProfileContainer: false
    }
  },
  created() {
    // this.$store.dispatch('user/getNotifications')
    window.addEventListener('click', this.close)
  },
  beforeUnmount() {
    window.removeEventListener('click', this.close)
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    isAdmin() {
      return this.$store.state.auth.isAdmin
    },
    showProfile() {
      return this.showProfileContainer ? 'show' : ''
    },
    getModeClass() {
      if (localStorage.getItem('mode') === 'dark') return 'btn-secondary'
      else return 'btn-light'
    },
    getModeIconClass() {
      if (localStorage.getItem('mode') === 'dark') return 'mdi-lightbulb-outline'
      else return 'mdi-lightbulb-on-outline'
    },
    role() {
      if (this.isAdmin) {
        return 'Admin'
      } else if (this.user.roles.length > 0) {
        return this.user.roles[0].name
      }

      return ''
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toggleProfileDropDown() {
      this.showProfileContainer = !this.showProfileContainer
    },
    close(e) {
      if (!this.$refs.userProfileRef.contains(e.target)) {
        this.showProfileContainer = false
      }
    }
  }
}
</script>
<style></style>
